module.exports = __webpack_public_path__ + "img/macmillan-cancer-support.44b0dcbe.png";